import { Icon, Text } from '@kanda-libs/ks-design-library';

const ViewOnlyNotice: React.FunctionComponent = function () {
  return (
    <div className="sticky top-24 md:top-32 flex flex-row px-3 py-2 md:px-4 md:py-5 mb-3 md:mb-4 bg-purple-50 border border-purple-300 rounded-lg z-50">
      <Icon
        icon="info"
        stroke="purple-300"
        size={16}
        className="mt-px mb-auto mr-3"
      />
      <Text
        className="text-purple-300 text-12-18-em"
        text="This document is view only - scroll to the bottom of this page to sign this document"
      />
    </div>
  );
};

export default ViewOnlyNotice;
